import styled from 'styled-components';

export default styled.div`
  align-self: center;
  position: relative;
  padding: 1rem 0 1rem 1rem;
`;
